import { useEffect, useMemo, useState } from 'react';

export const useForm = ( initialForm = {} ) => {
  
    const [ formState, setFormState ] = useState( initialForm );
    
    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onInputNumberChange = ({ target }) => {
        const { name, value } = target;

        if (value < 0) return;
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const formatNumber = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    };

    const onInputChangeThousands = ({ target }) => {
        const { name, value } = target;
        const newValue = formatNumber(value)
        setFormState({
            ...formState,
            [ name ]: value,
            [ `${name}_formateado` ]: newValue
        });
    }

    const onSelectSearchChange = (event) => {
        const { name, value } = event.target
        setFormState({
            ...formState,
            [ name ]: value
        });
    }

    const onCheckboxChange = (event) => {
        const { name, checked } = event.target
        setFormState({
            ...formState,
            [ name ]: checked
        });
    }

    const onDropZoneAcceptedFilesChange = (arrayAccepted) => {
        setFormState({
            ...formState,
            acceptedFiles: arrayAccepted
        });
    }

    const onDropZoneRejectionsFilesChange = (arrayRejections) => {
        setFormState({
            ...formState,
            fileRejections: arrayRejections
        });
    }

    const onResetForm = () => {
        setFormState( initialForm );
    }

    return {
        ...formState,
        formState,
        setFormState,
        onInputChange,
        onInputNumberChange,
        onInputChangeThousands,
        onSelectSearchChange,
        onCheckboxChange,
        onResetForm,
        onDropZoneAcceptedFilesChange,
        onDropZoneRejectionsFilesChange
    }
}